import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoadingIcon from '../../../common/icons/LoadingIcon';
import RelatedItemEdit from './RelatedItemEdit';
import RelatedItemThumbnail from './RelatedItemThumbnail';

import styles from './_styles/EditRelatedItems.module.scss';

const allActionCreators = Object.assign({});

export class EditRelatedItems extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {
			editing: false,
			editingItem: null,
		};
	}

	openEditing(itemEdit = null) {
		this.setState({
			editing: true,
			editingItem: itemEdit,
		});
	}

	closeEditing() {
		this.setState({
			editing: false,
			editingItem: null,
		});
	}
	
	render() {

		if(!this.props.product) {
			return null;
		}

		return <div className={`${styles.EditRelatedItems}`}>
			<div className={styles.body}>

				{this.state.editing 
					?	<div className={styles.editingWrapper}>
							<RelatedItemEdit
								product={this.props.product}
								item={this.state.editingItem}
								refresh={this.props.refresh}
								closeAction={this.closeEditing.bind(this)} />
						</div>
					:	<>
							{this.props.product?.related_items?.length > 0
								?	<div className={styles.thumbnailsWrapper}>
										{this.props.product?.related_items.map((ri, n) => {

											return <RelatedItemThumbnail
														key={ri.id}
														product={this.props.product}
														item={ri}
														onClick={() => this.openEditing(ri)} />
										})}
										
										<div className={styles.addRow}>
											<div className={styles.addLink} onClick={() => this.openEditing()}>Add New Related Item</div>
										</div>
										
									</div>
								:	<div className={styles.noItemsWrapper}>
										<div className={styles.copy}>No related items</div>
										<div className={styles.add} onClick={() => this.openEditing()}>Add</div>
									</div>
							}
						</>
				}
				
				{this.props.loading && (
					<div className={styles.loadingWrapper}>
						<div className={styles.iconWrapper}>
							<LoadingIcon />
						</div>
					</div>
				)}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(EditRelatedItems);